export default "/static/dashboard/build/app/img/v2/825058365e9fcec45a2c7e393323b601.png";